import { Cookie } from '../../model/browser/cookie';
import { isEmpty } from 'es-toolkit/compat';

export const convertCookieToKey = (cookie?: Cookie) => {
  if (!isEmpty(cookie?.name) && !isEmpty(cookie?.value)) {
    return `${cookie?.name}=${cookie?.value}`;
  }
};
